import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";



export async function getApplicationDropdown(request) {
    try {
        const response = await axiosApi.post(`/Application/getApplicationDropdown`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getApplicationDropdown===>:", error);
        return null;
    }
};

export async function getApplicationList(request) {
    try {
        //debugger;
        const response = await axiosApi.post(`/Application/GetApplicationList`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getApplicationList===>:", error);
        return null;
    }
};

export async function GetApplicationsByUserId(userId) {
    try {
        let request = {};
        const response = await axiosApi.post(`/Application/GetApplicationsByUserId/${userId}`, request);
        return response?.data?.data;
    } catch (error) {
        console.log('Error GetApplicationsByUserId===>:', error);
        return null;
    }
};

export async function GetAssignedUnAssignedApplicationsByUserId(userId) {
    try {
        let request = {};
        const response = await axiosApi.post(`/Application/GetAssignedUnAssignedApplicationsByUserId/${userId}`, request);
        return response?.data?.data;
    } catch (error) {
        console.log('Error GetApplicationsByUserId===>:', error);
        return null;
    }
};

export async function CreateUserApplicationAccess(request) {
    try {
        const response = await axiosApi.post(`/UserFeature/CreateUserApplicationAccess`, request);
        return response?.data;
    } catch (error) {
        console.log('Error CreateUserApplicationAccess===>:', error);
        return null;
    }
};

const getAllApplicationsWithUserAccess = async (request) => {
    try {
        request = request || {};
        request.companyId = getReduxCompany()?.id || 0;
        const response = await axiosApi.post(`Application/GetAllApplicationsWithUserAccess`, request);
        return response?.data;
    } catch (error) {
        console.log("Error getAllApplicationsWithUserAccess ===>", error);
        return error?.response?.data;
    }
};



export const ApplicationService = {
    getApplicationDropdown,
    getApplicationList,
    GetApplicationsByUserId,
    GetAssignedUnAssignedApplicationsByUserId,
    getAllApplicationsWithUserAccess
}
